import React, {useRef, useState, useEffect} from "react";
import ReactQuill from 'react-quill';
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import classnames from "classnames";
import {useSelector} from "react-redux";
import API from "../../utils/API";
import uniqid from 'uniqid';
import {FaLink} from "react-icons/fa";
import Modal from 'react-modal'
import 'react-quill/dist/quill.snow.css';

const TextEditor = (props) => {

    const app = useSelector(state => {
        return state.app
    });

    const [linkModal, setLinkModal] = useState(false)

    const [activeTab,setActiveTab] = useState("page")

    const [pages,setPages] = useState(null)

    const [linkPageSelected,setLinkPageSelected] = useState(null)
    const [webUrl,setWebUrl] = useState(null)
    const [email,setEmail] = useState(null)
    const [phone,setPhone] = useState(null)
    const [file,setFile] = useState(null)
    const [fileLoading,setFileLoading] = useState(false)

    const [ready,setReady] = useState(false)

    const quillRef = useRef()

    const blockId = uniqid()

    const Quill = ReactQuill.Quill;

    let Size = Quill.import('attributors/style/size');
    Size.whitelist = ['10px', '11px', '12px','13px','14px','15px','16px','17px','18px','19px','20px','21px','22px','23px','24px','25px','26px','27px','28px','29px','30px'];
    Quill.register(Size, true);

    let Font = Quill.import("attributors/class/font");
    Font.whitelist = ["Assistant", "BebasNeue", "Caveat","Cinzel","DancingScript","IndieFlower", "JosefinSans", "Lato", "Lobster", "Lora" ,"Merriweather","Montserrat","Nunito","Oswald","OpenSans", "Poppins","Raleway","Roboto", "Redressed","Rubik","Shizuru","Ubuntu"];
    Quill.register(Font, true);

    const BubbleTheme = Quill.import('themes/bubble');

    class ExtendBubbleTheme extends BubbleTheme {
        constructor(quill, options) {
            super(quill, options);

            quill.on('selection-change', range => {
                if (range) {
                    quill.theme.tooltip.show();
                    quill.theme.tooltip.position(quill.getBounds(range));
                }
            });
        }
    }

    Quill.register('themes/bubble', ExtendBubbleTheme);

    const pageeditor = useSelector(state => {
        return state.pageEditor
    });

    useEffect(()=>{
        if (quillRef.current) {
            let toolbar = quillRef.current.getEditor().getModule('toolbar');
            toolbar.addHandler('link',()=>{
                if (pageeditor.app) {
                    API.get('/page/getall/'+pageeditor.app).then((response) => {
                        setPages(response.data.data);
                        setLinkModal(true)
                    });
                }
            })
        }
    },[quillRef.current])

    const modules = {
        toolbar: {
            container: [
                [{ size: ['','10px', '12px','14px','16px','18px','20px','22px','24px','26px','28px','30px'] },{ font: ["","Assistant", "BebasNeue", "Caveat", "Cinzel","DancingScript", "IndieFlower", "JosefinSans", "Lato", "Lobster", "Lora" ,"Merriweather","Montserrat","Nunito","OpenSans", "Oswald","Poppins","Raleway","Roboto", "Redressed","Rubik","Shizuru","Ubuntu"] },{ 'align': ['','right','center','justify']},{ 'color': ['#000000','#800000','#008000','#808000','#000080','#800080','#008080','#c0c0c0','#808080','#ff0000','#00ff00','#ffff00','#0000ff','#ff00ff','#00ffff','#ffffff','#000000','#00005f','#000087','#0000af','#0000d7','#0000ff','#005f00','#005f5f','#005f87','#005faf','#005fd7','#005fff','#008700','#00875f','#008787','#0087af','#0087d7','#0087ff','#00af00','#00af5f','#00af87','#00afaf','#00afd7','#00afff','#00d700','#00d75f','#00d787','#00d7af','#00d7d7','#00d7ff','#00ff00','#00ff5f','#00ff87','#00ffaf','#00ffd7','#00ffff','#5f0000','#5f005f','#5f0087','#5f00af','#5f00d7','#5f00ff','#5f5f00','#5f5f5f','#5f5f87','#5f5faf','#5f5fd7','#5f5fff','#5f8700','#5f875f','#5f8787','#5f87af','#5f87d7','#5f87ff','#5faf00','#5faf5f','#5faf87','#5fafaf','#5fafd7','#5fafff','#5fd700','#5fd75f','#5fd787','#5fd7af','#5fd7d7','#5fd7ff','#5fff00','#5fff5f','#5fff87','#5fffaf','#5fffd7','#5fffff','#870000','#87005f','#870087','#8700af','#8700d7','#8700ff','#875f00','#875f5f','#875f87','#875faf','#875fd7','#875fff','#878700','#87875f','#878787','#8787af','#8787d7','#8787ff','#87af00','#87af5f','#87af87','#87afaf','#87afd7','#87afff','#87d700','#87d75f','#87d787','#87d7af','#87d7d7','#87d7ff','#87ff00','#87ff5f','#87ff87','#87ffaf','#87ffd7','#87ffff','#af0000','#af005f','#af0087','#af00af','#af00d7','#af00ff','#af5f00','#af5f5f','#af5f87','#af5faf','#af5fd7','#af5fff','#af8700','#af875f','#af8787','#af87af','#af87d7','#af87ff','#afaf00','#afaf5f','#afaf87','#afafaf','#afafd7','#afafff','#afd700','#afd75f','#afd787','#afd7af','#afd7d7','#afd7ff','#afff00','#afff5f','#afff87','#afffaf','#afffd7','#afffff','#d70000','#d7005f','#d70087','#d700af','#d700d7','#d700ff','#d75f00','#d75f5f','#d75f87','#d75faf','#d75fd7','#d75fff','#d78700','#d7875f','#d78787','#d787af','#d787d7','#d787ff','#d7af00','#d7af5f','#d7af87','#d7afaf','#d7afd7','#d7afff','#d7d700','#d7d75f','#d7d787','#d7d7af','#d7d7d7','#d7d7ff','#d7ff00','#d7ff5f','#d7ff87','#d7ffaf','#d7ffd7','#d7ffff','#ff0000','#ff005f','#ff0087','#ff00af','#ff00d7','#ff00ff','#ff5f00','#ff5f5f','#ff5f87','#ff5faf','#ff5fd7','#ff5fff','#ff8700','#ff875f','#ff8787','#ff87af','#ff87d7','#ff87ff','#ffaf00','#ffaf5f','#ffaf87','#ffafaf','#ffafd7','#ffafff','#ffd700','#ffd75f','#ffd787','#ffd7af','#ffd7d7','#ffd7ff','#ffff00','#ffff5f','#ffff87','#ffffaf','#ffffd7','#ffffff','#080808','#121212','#1c1c1c','#262626','#303030','#3a3a3a','#444444','#4e4e4e','#585858','#606060','#666666','#767676','#808080','#8a8a8a','#949494','#9e9e9e','#a8a8a8','#b2b2b2','#bcbcbc','#c6c6c6','#d0d0d0','#dadada','#e4e4e4','#eeeeee'] }],
                ['bold', 'italic', 'underline','link','image']
            ]
        }
    }

    const formats = [
        'size','font','list',
        'bold', 'italic', 'underline', 'link','color','background','color','align','image'
    ]

    return (
        <div
            onClick={(e)=>e.stopPropagation()} className="snowEditor"
        >
            <ReactQuill
                ref={quillRef}
                id={blockId}
                bounds=".appEditContainer"
                defaultValue={props.value}
                formats={formats}
                onChange={(value)=>{
                    if (ready) props.setValue(props.name,value)
                }}
                modules={modules}
                onFocus={()=>{setReady(true)}}
                theme="snow"
            />
            <Modal
                isOpen={linkModal}
                toggle={() => setLinkModal(!linkModal)}
                className={"modal-window"}
                overlayClassName="modal-overlay"
                onRequestClose={()=>setLinkModal(false)}
            >
                <div>
                    <div className="modalTitle row justify-content-center">
                        <div className="col-auto icon">
                            <FaLink/>
                        </div>
                        <div className="col-auto text pt-2">
                            Link to
                        </div>
                    </div>
                    <div className={"mt-2 tab default"}>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "page" },'cursorPointer')}
                                    onClick={() => {
                                        setActiveTab("page");
                                    }}
                                >
                                    <strong>Page</strong>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "webaddress" },'cursorPointer')}
                                    onClick={() => {
                                        setActiveTab("webaddress");
                                    }}
                                >
                                    <strong>Web address</strong>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "email" },'cursorPointer')}
                                    onClick={() => {
                                        setActiveTab("email");
                                    }}
                                >
                                    <strong>Email</strong>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "phone" },'cursorPointer')}
                                    onClick={() => {
                                        setActiveTab("phone");
                                    }}
                                >
                                    <strong>Phone</strong>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "file" },'cursorPointer')}
                                    onClick={() => {
                                        setActiveTab("file");
                                    }}
                                >
                                    <strong>File</strong>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className="mt-2">
                            <TabPane tabId="page">
                                <select className="form-control" onChange={(e)=>{setLinkPageSelected(e.target.value)}}>
                                    <option value={null}>Select app page</option>
                                    {pages &&
                                        pages.map((page,index)=>{
                                            return (
                                                <option key={index} value={page.id}>{page.title}</option>
                                            )
                                        })
                                    }
                                </select>
                            </TabPane>
                            <TabPane tabId="webaddress">
                                <input type="text" onChange={(e)=>setWebUrl(e.target.value)} className="form-control" placeholder="Web address"/>
                            </TabPane>
                            <TabPane tabId="email">
                                <input type="text" onChange={(e)=>setEmail(e.target.value)} className="form-control" placeholder="Email"/>
                            </TabPane>
                            <TabPane tabId="phone">
                                <input type="text" onChange={(e)=>setPhone(e.target.value)} className="form-control" placeholder="Phone"/>
                            </TabPane>
                            <TabPane tabId="file">
                                <input type="file" className="form-control-file" placeholder="File" onChange={(event) => {
                                    let files = event.target.files;
                                    let reader = new FileReader();
                                    reader.readAsDataURL(files[0]);

                                    reader.onload = (e) => {
                                        setFileLoading(true)
                                        API.post('/page/file/upload',{base64:e.target.result,name:files[0].name}).then((response) => {
                                            setFile(response.data.data)
                                            setFileLoading(false)
                                        });
                                    }
                                }}/>
                            </TabPane>
                        </TabContent>
                    </div>
                    <div className="row justify-content-center mt-2">
                        <div className="col-auto">
                            <div className="button" onClick={() => {
                                if (!fileLoading) {
                                    if (activeTab === 'page' && linkPageSelected) {
                                        quillRef.current.getEditor().format('link', 'apppagelink' + linkPageSelected)
                                        setActiveTab("page")
                                        setLinkModal(false)
                                    } else if (activeTab === 'webaddress' && webUrl) {
                                        quillRef.current.getEditor().format('link', webUrl)
                                        setActiveTab("email")
                                        setLinkModal(false)
                                    } else if (activeTab === 'email' && email) {
                                        quillRef.current.getEditor().format('link', 'mailto:' + email)
                                        setActiveTab("email")
                                        setLinkModal(false)
                                    } else if (activeTab === 'phone' && phone) {
                                        quillRef.current.getEditor().format('link', 'tel:' + phone)
                                        setActiveTab("phone")
                                        setLinkModal(false)
                                    } else if (activeTab === 'file' && file) {
                                        quillRef.current.getEditor().format('link', file)
                                        setActiveTab("file")
                                        setLinkModal(false)
                                    }
                                }
                            }}>Insert link</div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default TextEditor
